<div class="blank-layout-container justify-content-center align-items-center">
    <div class="position-relative row w-100 h-100 bg-gredient justify-content-center">
      <div class="col-lg-4 d-flex align-items-center">
        <mat-card class="cardWithShadow boxed-auth">
          <mat-card-content class="p-32">
            <div class="text-center">
              <img src="assets/images/logos/clu-dark-logo.svg" class="align-middle m-2" alt="logo" width="100%" />
            </div>

            <ng-container *ngIf="state == 'idle'">
              <div class="or-border m-t-30 m-b-30">Mise à jour Application</div>
              <mat-label class="mat-subtitle-2 f-s-14 d-block text-center">Version actuelle: <strong>{{ !!appVersion ? appVersion.APP_VERSION_ID : "" }}</strong></mat-label>
              <mat-label class="mat-subtitle-2 f-s-14 m-b-12 d-block text-center">Une mise à jour vers la version <strong>{{ !!serverVersion ? serverVersion.APP_VERSION_ID : "" }}</strong> est disponible.</mat-label>
              <div class="error-container" *ngIf="!!errorText">{{ errorText }}</div>
              <button mat-flat-button color="primary" class="w-100" (click)="doInstallUpdatesAction()" [disabled]="loading">
                Installer la mise à jour
              </button>
            </ng-container>
            <ng-container *ngIf="state == 'downloading'">
              <div class="or-border m-t-30 m-b-30">Mise à jour Application</div>
              <mat-label class="mat-subtitle-2 f-s-14 d-block text-center">Téléchargement de la mise à jour en cours...</mat-label>
              <mat-label class="mat-subtitle-2 f-s-12 m-b-12 d-block text-center"><strong>{{ progress }}%</strong></mat-label>
              <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
              <div class="error-container" *ngIf="!!errorText">{{ errorText }}</div>
              <button mat-flat-button color="warn" class="w-100" (click)="doCancelUpdatesAction()" style="margin-top: 15px">
                Annuler
              </button>
            </ng-container>
            <ng-container *ngIf="state == 'downloaded'">
              <div class="or-border m-t-30 m-b-30">Mise à jour Application</div>
              <mat-label class="mat-subtitle-2 f-s-14 d-block text-center">Installation de la mise à jour en cours...</mat-label>
            </ng-container>

          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
